import request from "@/utils/request"
// 获取收款账户信息
export const getpayinfo = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/Baohan/getpayinfo",
    });
};
// 支付信息提交
export const bhpay = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/Baohan/bhpay",
    });
};


// WEBPACK FOOTER //
// ./src/api/houer.js